import React, { Fragment } from "react";
import classnames from "classnames";
import PropTypes from "prop-types";

// import './step-progress.scss';

const StepProgress = ({
  className,
  classes,
  theme,
  states,
  stepNames,
  stepStates,
  navi,
  vertical,
}) => {
  /* states: a zero-based array of states, representing the classes applied to the elements
  not-started: a step that a user hasn't visited yet
  incomplete: a step a user has visited but isn't currently on
  in-progress: the current step a user is on
  complete: a step a user has visited and finished
  processed: a step a user has visited, finished, and some background process has acted upon
*/

  const { layout, base, icon } = classes,
    vertClass = !vertical ? layout.horiz : layout.vert,
    compClasses = classnames({
      [classes.base]: true,
      [className]: className,
      [theme]: true,
      [vertClass]: true,
    });

  function renderIcon(iconClass, idx) {
    const num = idx + 1;
    return (
      <Fragment>
        <i className={icon} aria-hidden={true}></i>
        <span className="step-progress-number">
          <span className="text show-for-sr">Step</span>
          <span className="number">{num}</span>
        </span>
      </Fragment>
    );
  }

  return (
    <ol className={compClasses}>
      {stepNames.map((step, idx) => {
        const num = idx + 1,
          curState = states[stepStates[idx]],
          iconClass = icon,
          itemClass = `${base}-item ${curState}`,
          keyNum = `step-${num}`,
          circleClass = `${base}-circle`,
          numClass = `${base}-number`,
          nameClass = `${base}-name text`;

        return (
          <li className={itemClass} key={keyNum}>
            <span className={circleClass}>
              {curState === "complete" || curState === "processed" ? (
                renderIcon(iconClass, idx)
              ) : (
                <span className={numClass}>
                  <span className="text show-for-sr">Step</span>
                  <span className="number">{num}</span>
                </span>
              )}
            </span>
            {navi ? (
              <a href={step.href}>{step.text}</a>
            ) : (
              <span className={nameClass}>{step.text}</span>
            )}
          </li>
        );
      })}
    </ol>
  );
};

StepProgress.defaultProps = {
  classes: {
    base: "step-progress",
    icon: "icon",
    layout: {
      vert: "l-vert",
      horiz: "l-horiz",
    },
  },
  states: ["not-started", "incomplete", "in-progress", "complete", "processed"],
  stepNames: [{ text: "Step 1" }, { text: "Step 2" }, { text: "Step 3" }],
  stepStates: [2, 0, 0],
  navi: false,
  vertical: false,
  theme: "lc-2",
};

StepProgress.propTypes = {
  className: PropTypes.string,
  classes: PropTypes.object.isRequired,
  theme: PropTypes.string.isRequired,
  states: PropTypes.array.isRequired,
  stepNames: PropTypes.array.isRequired,
  stepStates: PropTypes.array.isRequired,
  vertical: PropTypes.bool,
  navi: PropTypes.bool,
};

export default StepProgress;

